import { useTranslation } from "react-i18next";
import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow";
import { FC, useState } from "react";
import { ChequePaymentType } from "../../../../../@types/enumsGlobal";
import { IRadioButtonOption, RadioGroup } from "../../../../../components/radioGroup/radioGroup";

interface IPaymentTypeWindowProps {
    readonly idDocumentGlobal: string
    readonly docNum: string
    readonly cancel: () => void
    readonly ok: (paymentType: ChequePaymentType) => void
}

export const PaymentTypeModal : FC<IPaymentTypeWindowProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.cheque.paymentType.' + value)

   
    
    const paymentTypeOptions: IRadioButtonOption[] = [
        {
            displayName: baseT("сash"),
            value: ChequePaymentType.Cash  // = 1
        },
        {
            displayName: baseT("сard"),
            value: ChequePaymentType.Card   // = 2
        },
        {
            displayName: baseT("credit"),
            value: ChequePaymentType.Credit // = 4
        }
    ];

    const [selectedPaymentType, setSelectedPaymentType] = useState<IRadioButtonOption>(paymentTypeOptions[0]);

    return ( 
        <BaseModalWindow
            header={props.docNum}
            cancel={{
                onClick: () => {
                    props.cancel();
                }
            }} 
            ok={{
                onClick: () => {
                    if (selectedPaymentType?.value){
                        props.ok(selectedPaymentType?.value)
                    }
                }
            }}>
            <RadioGroup
                value={selectedPaymentType}
                options={paymentTypeOptions}
                onSelect={(select) => {
                    if (select)
                    setSelectedPaymentType(select)
                }}
                vertical={true}
            />
          
        </BaseModalWindow>)
}